import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const UserName = 'UserName'
const BbsTokenKey = 'userToken'
const expires = 7;

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token, { expires })
}

export function setBbsToken (token) {
  // cookie 有效期为7天
  return Cookies.set(BbsTokenKey, token, { expires })
}

export function removeToken () {
  Cookies.remove(TokenKey)
  Cookies.remove(BbsTokenKey)
}

export function setUserName (name) {
  return Cookies.set(UserName, name, { expires })
}

export function removeUserName () {
  return Cookies.remove(UserName)
}

export function getUserName () {
  return Cookies.get(UserName)
}
